import { useState } from 'react'
import styled from 'styled-components'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { selectSubProfile, } from '../../features/signup/signupSlice'
import useSetFocus from '../../hooks/useSetFocus'
import { useSubmitProfileMutation } from '../../features/api/apiSlice'

const FormContent = () => {
  const [emailValue,setEmailValue] = useState("");
  const [chapterValue,setChapterValue] = useState("UG")
  const [passwordValue, setPassword] = useState("")

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const subProfileData = useSelector(selectSubProfile)

  function handleEmailChange(e){
    setEmailValue(e.target.value);
  }

  function handleChapterChange(e){
    setChapterValue(e.target.value);
  }

  function handlePasswordChange(e){
    setPassword(e.target.value);
  }

  useSetFocus('input[type="email"]');

  const [submitProfile,{isLoading,isError,isSuccess,error}] = useSubmitProfileMutation()

  const canSubmit = [emailValue,chapterValue, passwordValue].every(Boolean) && !isLoading

  async function handleSubmitProfile(e){
    e.preventDefault()

    if(canSubmit){
      try{
        const result = await submitProfile({...subProfileData,"email":emailValue,"chapter":chapterValue, "password":passwordValue})

        /*if(result.data?.New_Client_Profile_X === true){
          navigate('/')
        }*/
      }catch(err){
      }
    }
  }

  return (
    <Form action='' method='POST'>
      <div className="form-input">
        <input type="email" onChange={handleEmailChange} name='email' id='email' className='input-field' required />
        <label for="email" className={`input-label ${emailValue && 'fixed'}`}>Email</label>
      </div>
      <div className="form-input">
        <label for="chapter" className='input-label fixed'>Chapter</label>
        <select name='chapter' id='chapter' className='input-field select-field' onChange={handleChapterChange}>
          <option value="UG">University of Ghana (UG)</option>
          <option value="UCC">University of Cape coast (UCC)</option>
          <option value="KNUST">Kwame Nkrumah University of Science and Technology (KNUST)</option>
          <option value="UDS">University of Development Studies (UDS)</option>
          <option value="None">None</option>
        </select>
      </div>
      <div className="form-input" >
        <input type="password" onChange={handlePasswordChange} name='password' id='password' className='input-field' required />
        <label for="password" className={`input-label ${passwordValue && 'fixed'}`}>Password</label>
      </div>
      <p>By clicking "Sign up," you agree to our <Link to="/legal/terms-of-use">Terms of Use</Link> and our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
      <button className='signup-btn' onClick={handleSubmitProfile} disabled={isLoading}>Submit</button>
    </Form>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1em;
  margin: 2em auto;
  .form-input{
    position: relative;
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: .5em auto;
      &:focus-within .input-label{
        transform: translate(0, -.5em) scale(0.8);
      }
    .input-field{
      width: 90%;
      padding: .7em 1em;
      border: none;
      outline: none;
      border-bottom: 1px solid var(--color-muted-black-light);
      font-size: 1.1rem;
      &:focus{
        border-bottom: 2px solid var(--primary-color);
      }
    }
    .select-field{
      width: 100%;
      padding: 1.2em 0.7em;
    }
    .input-label{
      position: absolute;
      pointer-events: none;
      transform: translate(0, .8em) scale(1);
      transform-origin: top left;
      transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
      color: var(--color-muted-black);
      font-size: 1rem;
      left: 1em;
    }
    .fixed{
      transform: translate(0, -.5em) scale(0.8);
    }
  }

  p{
    font-size: 0.8rem;
    width: 80%;
    a{
      color: var(--primary-color);
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .signup-btn{
    width: 80%;
    padding: 1em 1em;
    border: none;
    border-radius: 50px;
    outline: none;
    font-size: 1.1rem;
    background-color: var(--primary-color);
    color: var(--color-white);
    cursor: pointer;
    &:disabled{
      background-color: var(--color-muted-black-light);
    }
  }

  @media only screen and (min-width: 1200px) {
     .form-input{
      width: 70%;
     }
     p{
      width: 60%;
     }
     .signup-btn{
      width: 60%;
     }
  }
`;

export default FormContent